import { useState } from "react";
import { categories, works } from "@/mocks/manga";
import SectionTitle from "./SectionTitle";

export default function Works() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? works : works.filter((w) => w.category === active);

  return (
    <section id="works" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          eyebrow="在追作品"
          title="本周大家都在追什么"
          desc="热门连载作品持续更新，加入追更列表后自动开启更新提醒，最新章节推送直达，进度随时掌握。"
        />

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2 px-1 py-1">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setActive(c)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((w) => (
            <article
              key={w.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={w.cover}
                  alt={`${w.title} 漫画封面`}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-semibold ${
                    w.status === "完结" ? "bg-secondary-500 text-background-50" : "bg-accent-500 text-foreground-950"
                  }`}
                >
                  {w.status}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base text-foreground-950">{w.title}</h3>
                  <span className="whitespace-nowrap text-xs text-foreground-500">{w.category}</span>
                </div>
                <p className="mt-1.5 text-sm text-foreground-600">{w.latestChapter}</p>
                <div className="mt-3 flex flex-wrap items-center gap-1.5">
                  {w.tags.map((t) => (
                    <span key={t} className="rounded-full bg-background-200 px-2.5 py-0.5 text-xs text-foreground-600">
                      {t}
                    </span>
                  ))}
                </div>
                <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">{w.updateDay}</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600">
                    <i className="ri-add-circle-line text-base"></i>
                    加入追更
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}